import { Visibility, VisibilityOff } from "@mui/icons-material";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { Box, Card, CardContent, IconButton, Switch } from "@mui/material";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { default as api, default as Api } from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import { aesDecrypt, aesEncrypt } from "../Atom/Crypto";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/MemberDetailPage.css";

const { Title } = Typography;

export default function MemberDetailPage() {
  const location = useLocation();
  const key = location.state;
  let navigate = useNavigate();
  const LoginState = useRecoilValue(loginState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const WH = useRecoilValue(WHState);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [member, setMember] = useState<any>({
    p_id: 0,
    name: "",
    manager: 0,
    id: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const changeTextField = (value: any) => {
    if (value.name == "name") {
      setMember((prev: any) => ({
        ...prev,
        name: value.value,
      }));
    } else if (value.name == "id") {
      setMember((prev: any) => ({
        ...prev,
        id: value.value,
      }));
    } else if (value.name == "password") {
      setMember((prev: any) => ({
        ...prev,
        password: value.value,
      }));
    }
  };

  const changeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name == "manager") {
      setMember((prev: any) => ({
        ...prev,
        manager: event.target.checked == true ? 1 : 0,
      }));
    }
  };

  const handleSave = () => {
    if (key.state == "register") {
      const getInsert = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("name", member.name);
        formData.append("manager", member.manager);
        formData.append("id", member.id);
        formData.append("password", aesEncrypt(member.password));

        const register = await Api.post(`/Employee/insertEmployee`, formData);
        setLoading(false);
        if (register != undefined) {
          navigate("/MemberPage");
        } else {
          setAlert(true);
          setAlertMessage("직원 등록에 실패하였습니다.");
        }
      };

      if (member.name == "" || member.id == "" || member.password == "") {
        setAlert(true);
        setAlertMessage("필수값을 채워주세요.");
      } else {
        getInsert();
      }
    } else if (key.state == "update") {
      const getUpdate = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("p_id", member.p_id);
        formData.append("name", member.name);
        formData.append("manager", member.manager);
        formData.append("id", member.id);
        formData.append("password", aesEncrypt(member.password));

        const updateData = await Api.put(`/Employee/updateEmployee`, formData);
        setLoading(false);
        if (updateData != undefined) {
          navigate(0);
        } else {
          setAlert(true);
          setAlertMessage("직원 정보 수정에 실패하였습니다.");
        }
      };

      if (member.name == "" || member.id == "" || member.password == "") {
        setAlert(true);
        setAlertMessage("필수값을 채워주세요.");
      } else {
        getUpdate();
      }
    }
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      if (key == null) {
        navigate("/NotFoundPage");
      } else {
        if (key.state != "register") {
          const getData = async () => {
            setLoading(true);
            const employee = await api.get(
              `/Employee/getEmployeeInfo?p_id=${key.p_id}`
            );
            setLoading(false);
            if (employee != undefined) {
              const newItem = {
                ...employee[0],
                password: aesDecrypt(employee[0].password),
              };
              setMember(newItem);
            } else {
              setAlert(true);
              setAlertMessage("데이터 조회에 실패하였습니다.");
            }
          };
          getData();
        }
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const DetailControlDiv = document.getElementById(
        "MemberDetailControlDiv"
      ) as HTMLElement;
      if (div && DetailControlDiv) {
        setdivBoxHeight(div.clientHeight - DetailControlDiv.clientHeight - 40);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="MemberDetailTitle">
        MemberDetailPage
      </Title>
      <div id="divbox">
        <Card className="MemberDetailCard">
          <CardContent
            className="MemberDetailCardContent"
            sx={{
              height: divboxHeight,
            }}
          >
            <Box className="MemberDetailForm">
              <Title level={4} className="MemberDetailName">
                이름
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="MemberDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="MemberAnswerIcon"
                  />
                  {member.name}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={member.name}
                  name="name"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="MemberDetailForm">
              <Title level={4} className="MemberDetailName">
                매니저 여부
              </Title>
              {key && key.state == "view" ? (
                <>
                  <Title level={5} className="MemberDetailName">
                    <ArrowForwardIos
                      fontSize="small"
                      className="MemberAnswerIcon"
                    />
                    <Switch
                      checked={member.manager == 1 ? true : false}
                      name="manager"
                    />
                  </Title>
                </>
              ) : (
                <Switch
                  checked={member.manager == 1 ? true : false}
                  required
                  name="manager"
                  onChange={changeSwitch}
                />
              )}
            </Box>
            <Box className="MemberDetailForm">
              <Title level={4} className="MemberDetailName">
                아이디
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="MemberDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="MemberAnswerIcon"
                  />
                  {member.id}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={member.id}
                  name="id"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="MemberDetailForm">
              <Title level={4} className="MemberDetailName">
                비밀번호
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="MemberDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="MemberAnswerIcon"
                  />
                  {member.password}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={member.password}
                  name="password"
                  fullWidth
                  onChange={changeTextField}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                      edge="end"
                      style={{ marginRight: "10px" }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  }
                />
              )}
            </Box>
          </CardContent>
          <Box id="MemberDetailControlDiv">
            {key && key.state != "view" && (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handleSave()}
                className="MemberSaveButton"
              >
                저장
              </ButtonComponent>
            )}
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => {
                navigate("/MemberPage");
              }}
              className="MemberCancelButton"
            >
              취소
            </ButtonComponent>
          </Box>
        </Card>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
